import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import AdmissionEnNonValeurComponent from '../../../../components/Mouvement/Panel/InformationsRattachement/AdmissionEnNonValeurComponent';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class AdmissionEnNonValeurPanel extends InformationsRattachementPanel {
	// Le bloc ne saisit que l'exercice de constitution et le n° de liste.
	isComplete = (data: Mouvement) =>
		this.isCompleteFor(data, 'exerRattachement', 'pieceOrigine');

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<AdmissionEnNonValeurComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default AdmissionEnNonValeurPanel;
